/**
 * @description table颗粒组件-内容copy
 * @param { keyContent: string | reactNode[键], valContent: string | reactNode[值], showDoint:boolean[是否显示短线-] }
 * @param { contentAlign: horizontal | vertical[排列方式], colon: boolean[键后面是否需要冒号], needCopy: boolean[是否需要copy功能] }
 * @returns 内容copy component or '-'
 */
import React from 'react';
import { Typography } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
// import classnames from 'classnames';

export default function TableContentCopy(props) {
  const { keyContent, valContent, showDoint = true, colon = true } = props;

  return (
    <>
      {keyContent || valContent ? (
        <div
          className="table-content-copy-wrapper"
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          {keyContent && (
            <span
              className="table-content-copy-key"
              style={{
                fontWeight: 600,
                color: 'rgba(0, 0, 0, 0.82)',
              }}
            >
              {keyContent}
            </span>
          )}
          {colon && <span className="table-content-copy-colon">:</span>}
          {valContent && (
            <span className="table-content-copy-val-fa" style={{ marginLeft: 8 }}>
              <Typography.Paragraph
                style={{ marginBottom: 0, lineHeight: '20px', display: 'flex' }}
                copyable={{
                  text: `${valContent || ''}`,
                  icon: <CopyOutlined style={{ color: 'rgba(0, 0, 0, 0.25)' }} />,
                }}
              >
                <span className="table-content-copy-val">
                  <span
                    style={{
                      fontWeight: 400,
                      color: 'rgba(0, 0, 0, 0.45)',
                    }}
                  >
                    {valContent || ''}
                  </span>
                </span>
              </Typography.Paragraph>
            </span>
          )}
        </div>
      ) : (
        <>{showDoint ? '-' : ''}</>
      )}
    </>
  );
}
